<div class="quote-details-form" [class.quote-readonly-mode]="isViewMode">
  <!-- Company Information Section -->
  <div class="material-row no-shadow">
    <div class="row d-flex align-items-center">
      <h6>Company Details</h6>
    </div>
    
    <div class="col-sm-12 mb-10">
      <strong [ngClass]="{'error-label': hasFieldError('companyName')}">
        Company Name<span class="asterisk">*</span>
      </strong>
      <input 
        type="text" 
        class="form-control company-name-input" 
        placeholder="Enter Company Name"
        [ngModel]="localQuoteDetails.companyName"
        (ngModelChange)="onFieldChange('companyName', $event)"
        (blur)="onFieldBlur('companyName')"
        (focus)="onFieldFocus('companyName')"
        [ngClass]="{'errorClass': hasFieldError('companyName'), 'disabled-input': integrationType === 'MFG'}"
        [disabled]="integrationType === 'MFG'"
        [readonly]="config.readonly">
    </div>
    
    <div class="row d-flex align-items-center mb-10">
      <div class="quote-information-container">
        <div class="company-email">
          <strong [ngClass]="{'error-label': hasFieldError('companyEmail')}">
            Company Email<span class="asterisk">*</span>
          </strong>
          <input 
            type="email" 
            class="form-control company-name-input"
            placeholder="Enter Company Email"
            [ngModel]="localQuoteDetails.companyEmail"
            (ngModelChange)="onFieldChange('companyEmail', $event)"
            (blur)="onFieldBlur('companyEmail')"
            (focus)="onFieldFocus('companyEmail')"
            [ngClass]="{'errorClass': hasFieldError('companyEmail'), 'disabled-input': integrationType === 'MFG'}"
            [disabled]="integrationType === 'MFG'"
            [readonly]="config.readonly">
        </div>
        
        <div class="company-phone-number">
          <strong [ngClass]="{'error-label': hasFieldError('companyPhone')}">
            Company Phone Number<span class="asterisk">*</span>
          </strong>
          <input 
            type="tel" 
            class="form-control company-name-input"
            placeholder="Enter Phone Number"
            [ngModel]="localQuoteDetails.companyPhone"
            (ngModelChange)="onFieldChange('companyPhone', $event)"
            (input)="clearCompanyPhoneError()"
            (paste)="clearCompanyPhoneError()"
            (blur)="onFieldBlur('companyPhone'); clearCompanyPhoneError()"
            (focus)="onFieldFocus('companyPhone')"
            [ngClass]="{'errorClass': hasFieldError('companyPhone'), 'error-placeholder': hasFieldError('companyPhone'), 'disabled-input': integrationType === 'MFG'}"
            [disabled]="integrationType === 'MFG'"
            [readonly]="config.readonly"
            maxlength="14"
            phoneFormat>
        </div>
      </div>
    </div>

    <!-- Quote Information Section -->
  <div class="material-row no-shadow">
    <div class="row d-flex align-items-center">
      <h6>Quote Information</h6>
    </div>
    
    <div class="quote-information-container">
      <div class="quote-number">
        <strong [ngClass]="{'error-label': hasFieldError('quoteNumber')}">
          Quote Number<span class="asterisk">*</span>
        </strong>
        <div class="input-group">
          <input 
            type="text" 
            class="form-control"
            placeholder="Enter Quote Number"
            [ngModel]="localQuoteDetails.quoteNumber"
            (ngModelChange)="onFieldChange('quoteNumber', $event)"
            (blur)="onFieldBlur('quoteNumber')"
            (focus)="onFieldFocus('quoteNumber')"
            [ngClass]="{'errorClass': hasFieldError('quoteNumber')}">
        </div>
      </div>
      
      <div class="valid-until-date">
        <strong [ngClass]="{'error-label': hasFieldError('quoteExpiryDate')}">
          Valid Until<span class="asterisk">*</span>
        </strong>
        <div class="input-group">
            <input 
            type="date" 
            class="form-control"
            placeholder="MM/DD/YYYY"
            [ngModel]="localQuoteDetails.quoteExpiryDate"
            (ngModelChange)="onQuoteExpiryDateChange($event)"
            (blur)="onQuoteExpiryDateBlur()"
            (focus)="onFieldFocus('quoteExpiryDate')"
            [ngClass]="{'errorClass': hasFieldError('quoteExpiryDate')}"
            [min]="getMinValidUntilDate()">
        </div>
      </div>
      
      <div class="payment-terms">
        <strong [ngClass]="{'error-label': hasFieldError('paymentTerm')}">
          Payment Terms<span class="asterisk">*</span>
        </strong>
        <select 
          class="form-select"
          [ngModel]="localQuoteDetails.paymentTerm"
          (ngModelChange)="onFieldChange('paymentTerm', $event)"
          (blur)="onFieldBlur('paymentTerm')"
          (focus)="onFieldFocus('paymentTerm')"
          [ngClass]="{'errorClass': hasFieldError('paymentTerm')}">
          <option value="">Select Payment Term</option>
          <option 
            *ngFor="let term of getPaymentTerms(); trackBy: trackByFieldName"
            [value]="term">
            {{ term }}
          </option>
        </select>
      </div>
    </div>
  </div>

    <!-- Additional fields for self-created RFQs -->
    <div class="row d-flex align-items-center">
      <h6>Shipping Address</h6>
    </div>
    <div class="row d-flex align-items-center mb-10">
      <div class="col-sm-12">
        <strong [ngClass]="{'error-label': hasFieldError('address')}">
          Company Address<span class="asterisk">*</span>
        </strong>
        <input 
          type="text" 
          class="form-control" 
          placeholder="Enter Company Address"
          [ngModel]="localQuoteDetails.address"
          (ngModelChange)="onFieldChange('address', $event)"
          (blur)="onFieldBlur('address')"
          (focus)="onFieldFocus('address')"
          [ngClass]="{'errorClass': hasFieldError('address'), 'disabled-input': integrationType === 'MFG'}"
          [disabled]="integrationType === 'MFG'"
          [readonly]="config.readonly">
      </div>
    </div>

    <div class="row d-flex align-items-center mt-3">
      <div class="quote-information-container">
        <div class="city-field">
          <strong [ngClass]="{'error-label': hasFieldError('city')}">
            City<span class="asterisk">*</span>
          </strong>
          <input 
            type="text" 
            class="form-control" 
            placeholder="Enter City"
            [ngModel]="localQuoteDetails.city"
            (ngModelChange)="onFieldChange('city', $event)"
            (keypress)="onCityStateKeyPress($event)"
            (blur)="onFieldBlur('city')"
            (focus)="onFieldFocus('city')"
            [ngClass]="{'errorClass': hasFieldError('city'), 'disabled-input': integrationType === 'MFG'}"
            [disabled]="integrationType === 'MFG'"
            [readonly]="config.readonly">
        </div>
        
        <div class="state-field">
          <strong [ngClass]="{'error-label': hasFieldError('state')}">
            State<span class="asterisk">*</span>
          </strong>
          <input 
            type="text" 
            class="form-control" 
            placeholder="Enter State"
            [ngModel]="localQuoteDetails.state"
            (ngModelChange)="onFieldChange('state', $event)"
            (keypress)="onCityStateKeyPress($event)"
            (blur)="onFieldBlur('state')"
            (focus)="onFieldFocus('state')"
            [ngClass]="{'errorClass': hasFieldError('state'), 'disabled-input': integrationType === 'MFG'}"
            [disabled]="integrationType === 'MFG'"
            [readonly]="config.readonly">
        </div>
        
        <div class="zip-code-field">
          <strong [ngClass]="{'error-label': hasFieldError('zipCode')}">
            Zip Code<span class="asterisk">*</span>
          </strong>
          <input 
            type="text" 
            class="form-control" 
            placeholder="Zip Code"
            [ngModel]="localQuoteDetails.zipCode"
            (ngModelChange)="onFieldChange('zipCode', $event)"
            (blur)="onFieldBlur('zipCode')"
            (focus)="onFieldFocus('zipCode')"
            [ngClass]="{'errorClass': hasFieldError('zipCode'), 'disabled-input': integrationType === 'MFG'}"
            [disabled]="integrationType === 'MFG'"
            [readonly]="config.readonly"
            maxlength="10">
        </div>
      </div>
    </div>
  </div>

  <div class="step-actions-button">
    <button 
      class="btn btn-secondary" 
      (click)="proceedToPartQuoting()"
      [disabled]="isFormSubmitting()">
      <span *ngIf="!isFormSubmitting()">Proceed to Part Quoting</span>
      <span *ngIf="isFormSubmitting()">
        <i class="fas fa-spinner fa-spin"></i> Saving...
      </span>
    </button>
  </div>

</div> 